import { render, staticRenderFns } from "./jySet.vue?vue&type=template&id=2bb7723d&scoped=true&"
import script from "./jySet.vue?vue&type=script&lang=js&"
export * from "./jySet.vue?vue&type=script&lang=js&"
import style0 from "./jySet.vue?vue&type=style&index=0&id=2bb7723d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7723d",
  null
  
)

export default component.exports